import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ScanSettings } from 'scandit-sdk';

import { BREAKPOINTS } from '@/common/constants';

import CONFIG from './config';

const useBarcodeScanner = ({
  className,
  onScanResult,
  togglePopin,
  isLogin,
}) => {
  const { t } = useTranslation();

  const [isActive, setIsActive] = useState(false);
  const [barcode, setBarcode] = useState(null);

  const scanSettings = useMemo(
    () => new ScanSettings(CONFIG.scandit.scanSettings),
    [],
  );

  const buttonLabel = useMemo(
    () =>
      isActive
        ? t('common:messages:actions.cancel')
        : t('common:messages:actions.scan'),
    [isActive, t],
  );

  const classNames = useMemo(
    () => [CONFIG.css.class, className].filter((val) => val).join(' '),
    [className],
  );

  const onToggleScan = useCallback(() => setIsActive(!isActive), [isActive]);

  useEffect(() => {
    if (
      (barcode &&
        isActive &&
        document.body.offsetWidth >= BREAKPOINTS.desktop) ||
      (barcode && isActive && isLogin)
    ) {
      onScanResult(barcode);
      setIsActive(false);
      setBarcode(null);
    }

    if (
      isActive &&
      barcode &&
      document.body.offsetWidth < BREAKPOINTS.desktop &&
      !isLogin
    ) {
      togglePopin(barcode);
      setIsActive(false);
      setBarcode(null);
    }
  }, [barcode, isActive, isLogin, onScanResult, togglePopin]);

  return {
    buttonLabel,
    classNames,
    onToggleScan,
    scanSettings,
    setBarcode,
  };
};

export default useBarcodeScanner;
